var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20945 0.592576L13.9133 7.64549C14.0289 7.76716 14.0289 7.96457 13.9133 8.08624L12.6563 9.40867C12.5406 9.53044 12.353 9.53044 12.2373 9.40867L6.99999 3.89856L1.76269 9.40867C1.64704 9.53044 1.45941 9.53044 1.34367 9.40867L0.0868062 8.08624C-0.0289356 7.96457 -0.0289356 7.76716 0.0868061 7.6455L6.79053 0.592576C6.90785 0.469143 7.09213 0.469143 7.20945 0.592576Z",
    fill: "#106C3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.beff608f18c05c2bd4df91e00f6f7f61.svg";
export { ForwardRef as ReactComponent };